export const DATES_FORMATS = {
  EN: "YYYY-MM-DD",
  LATIN: "DD-MM-YYYY",

  DEFAULT: "DD/MM/YYYY",
  DEFAULT_WITH_TIME: "DD/MM/YYYY HH:mm",
  MYSQL: "YYYY/MM/DD",
  MYSQL_SERVER: "YYYY-MM-DD",
  MYSQL_SERVER_TIMESTAMPS_DEFAULT: "YYYY-MM-DDTHH:mm:ss",
  MYSQL_SERVER_TIMESTAMPS_DEFAULT_24_HOURS: "YYYY-MM-DDTH:mm:ss",
  TIMESTAMPS_DEFAULT: "YYYY/MM/DD H:mm:ss",
  TIMESTAMPS_DEFAULT_24_HOURS: "YYYY/MM/DD H:mm:ss",
  TIMESTAMPS_WITHOUT_SECONDS_24_HOURS: "YYYY/MM/DD H:mm",
  TIME_DEFAULT: "HH:mm",
  // Constantes de unidades para plugin y manejo de fechas
  CONSTANTS: {
    UNITS: {
      DAYS: "days",
      WEEKS: "week",
      MONTHS: "month",
      YEARS: "year",
    },
  },
};
